const COUNT_PAGE_INDEX = 'countPage';

export const getCurrentPageNumber = () => {
    let countPage = 1;

    if (window.localStorage.getItem(COUNT_PAGE_INDEX) !== null) {
        countPage = window.localStorage.getItem(COUNT_PAGE_INDEX);
    }

    return countPage;
};
